var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 203 381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFCF02",
    strokeDasharray: 7,
    strokeWidth: 6.99,
    d: "M54.832 376.83c-42.03-8.12-58.28-40.69-47.69-81.33 32.78-125.88 182.55-43.14 168.33-249.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF02",
    d: "M174.962 49.03c-9.83 0-18.28-6.69-20.53-16.28a20.982 20.982 0 0 1 2.6-15.95c2.97-4.79 7.62-8.15 13.11-9.44 1.59-.38 3.23-.57 4.85-.57 9.83 0 18.27 6.69 20.53 16.28 2.67 11.33-4.38 22.72-15.71 25.38-1.59.38-3.23.57-4.85.57v.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg44);
export default __webpack_public_path__ + "static/media/44.0427fc4d931c00a1da4068f2df648955.svg";
export { ForwardRef as ReactComponent };